module.exports = __webpack_public_path__ + "img/modif_visiteur.c6a0a9ee.png";